#@export GliveBooking.Presenters.Price

class GliveBooking.Presenters.Price extends BookingV2.Presenters.Base

  module: 'glive-booking'

  toHash: ->
    selected:  @model.getPrice() == @options.selected?.getPrice()
    price:     @model.getFormattedPrice()
    value:     @model.getFormattedValue()
